import { SimulationTabs } from "./SimulationTabs"

export class SimulationUiState {
    
    public typeUiid:string        
    
    //public infosPanelVisible:boolean

    public tabsleft:SimulationTabs
    public tabsright:SimulationTabs
    public leftPanelWidth:string  

    constructor({typeUiid="detail", //detail ou global ou fleet 
                 tabsleft = new SimulationTabs({tabs : [] , selected : "SimulationMenu-0"}), tabsright = new SimulationTabs(), leftPanelWidth = "50%"} = {}) {
        this.typeUiid = typeUiid                            
        this.tabsleft = new SimulationTabs(tabsleft)
        this.tabsright = new SimulationTabs(tabsright)
        this.leftPanelWidth = leftPanelWidth
    }
} 

export const buildSimulationUIStateId = (MIG_ID:number,typeuiid:string) => {
    return `simulation_${MIG_ID}_${typeuiid}`
}

